module.exports = __webpack_public_path__ + "static/media/header-camps-1.ee980821.jpg";